module.exports = __webpack_public_path__ + "static/media/pin_grey.df796c03.svg";